module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.27b.6f36f5ed.jpg";